import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'

Vue.config.productionTip = false

// Make ElementUI selects searchable by default across the Vue app.
if (ElementUI.Select && ElementUI.Select.props) {
  ElementUI.Select.props.filterable = {
    type: Boolean,
    default: true
  }
  ElementUI.Select.props.noMatchText = {
    type: String,
    default: '没有对应的内容'
  }
  ElementUI.Select.props.noDataText = {
    type: String,
    default: '没有对应的内容'
  }
}

Vue.use(ElementUI)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
